(ns frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.fund-status
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer
    [empty-table-data?
     empty-chart-data?]]))

(defn fund-value-bridge-svg
  [{:keys [fund-status]}]
  (let [figures (-> fund-status
                    :fund-value-bridge
                    :figures)]
    (when-not (empty-chart-data? fund-status :fund-value-bridge)
      [(card/second-row-second-column-card
        "Fund value bridge"
        false
        {:svg (chart-view/chart-svg "highcharts"

                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [0 50 0 0]
                                                                  :margin  [0 100 80 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}
                                                         :xAxis  {:labels {:rotation 25
                                                                           :style    {:fontSize "7pt"}
                                                                           :align    "left"}}}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:fund-value-bridge fund-status)))])))

(defn value-progression-svg
  [{:keys [fund-status]}]
  (let [figures (-> fund-status
                    :value-progression
                    :figures)]
    (when-not (empty-chart-data? fund-status :value-progression)
      [(card/second-row-first-column-card
        "Value progression"
        false
        {:svg (chart-view/chart-svg "highcharts"

                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [10 50 0 0]
                                                                  :margin  [0 100 50 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:value-progression fund-status)))])))

(defn fund-status-page-1
  [data]
  (page/page
   (page/page-title-with-line {:fund-name  (:fund-name data)
                               :page-title "Fund overview - Executive Summary and Fund Performance Charts"
                               :toc-item   true})
   (card/first-row-card
    ""
    (text-content/rich-content (->> data
                                    :fund-overview
                                    :case-overview
                                    :rich-content)))
   (column/columns
    [(fund-value-bridge-svg data)]
    [(value-progression-svg data)])))

(defn fund-status-page-2
  [{:keys [fund-status] :as data}]
  (let [remove-page? (and (empty-table-data? fund-status :net-asset-value)
                          (empty-table-data? fund-status :key-metrics))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Net asset value and key metrics"
                                   :toc-item   true})
       (card/table-card ""
                        (horizontal-table-pdf/table (->> fund-status
                                                         :net-asset-value))
                        (text-content/optional-footer (->> fund-status
                                                           :net-asset-value)))
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-status
                                                       :key-metrics))
                        (text-content/optional-footer (->> fund-status
                                                           :key-metrics)))))))

(defn fund-status-pages
  [data]
  [(fund-status-page-1 data)
   (fund-status-page-2 data)])
